import{withEventListener}from"../with-event-listener";export var withBoundaries=a=>withEventListener(a);